module.exports = __webpack_public_path__ + "static/media/pagination-right-arrow.89ac6310.svg";